import React from 'react';
import { Link } from 'react-router-dom';

// Standard inline link for text content
export const InlineLink = ({ to, children }) => (
  <Link 
    to={to}
    className="text-primary-600 hover:text-primary-800 font-medium border-b-2 border-primary-200 hover:border-primary-600 transition-all duration-200"
  >
    {children}
  </Link>
);

// Card link for program listings
export const ProgramLink = ({ title, description, path, icon }) => (
  <Link 
    to={path}
    className="block bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-all duration-300 group relative overflow-hidden"
  >
    <div className="absolute inset-0 bg-primary-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    <div className="relative flex items-start gap-4">
      <span className="text-2xl bg-primary-100 p-3 rounded-lg">{icon}</span>
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <h3 className="text-xl font-semibold text-gray-900 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
        </div>
        <p className="text-gray-600 mt-2">{description}</p>
      </div>
    </div>
  </Link>
);

// Button link for CTAs
export const ButtonLink = ({ to, children, primary = true }) => (
  <Link
    to={to}
    className={`
      inline-flex items-center justify-center px-6 py-3 rounded-lg
      transition-all duration-200 font-medium
      ${primary 
        ? 'text-white bg-primary-600 hover:bg-primary-700 shadow-sm hover:shadow' 
        : 'text-primary-700 bg-white border border-primary-200 hover:bg-primary-50'
      }
    `}
  >
    {children}
  </Link>
);

// Resource link for documentation and resources
export const ResourceLink = ({ to, title, description }) => (
  <Link
    to={to}
    className="block p-4 rounded-lg hover:bg-primary-50 transition-colors duration-200 group"
  >
    <h4 className="text-lg font-medium text-gray-900 group-hover:text-primary-600 transition-colors">
      {title}
    </h4>
    {description && (
      <p className="text-gray-600 mt-1">{description}</p>
    )}
  </Link>
); 